const toothChartPostions = {
    11: {
        x: 0,
        y: 0,
    },
    12: {
        x: 0,
        y: 0,
    },
    13: {
        x: -5,
        y: 0,
    },
    14: {
        x: 0,
        y: 0,
    },
    15: {
        x: 0,
        y: 0,
    },
    16: {
        x: 0,
        y: 0,
    },
    17: {
        x: 0,
        y: 0,
    },
    18: {
        x: 0,
        y: -5,
    },
    21: {
        x: 0,
        y: 0,
    },
    22: {
        x: 0,
        y: 0,
    },
    23: {
        x: 5,
        y: 0,
    },
    24: {
        x: 0,
        y: 0,
    },
    25: {
        x: -3,
        y: 0,
    },
    26: {
        x: 0,
        y: 0,
    },
    27: {
        x: -3,
        y: 0,
    },
    28: {
        x: 0,
        y: -5,
    },
    41: {
        x: 0,
        y: -10,
    },
    42: {
        x: 0,
        y: 0,
    },
    43: {
        x: -5,
        y: 0,
    },
    44: {
        x: 0,
        y: 0,
    },
    45: {
        x: 3,
        y: 0,
    },
    46: {
        y: 0,
        x: 0,
    },
    47: {
        y: 0,
        x: 0,
    },
    48: {
        y: 0,
        x: 0,
    },
    31: {
        y: -10,
        x: 0,
    },
    32: {
        y: 0,
        x: 0,
    },
    33: {
        y: 0,
        x: +5,
    },
    34: {
        y: 0,
        x: 0,
    },
    35: {
        y: 0,
        x: 0,
    },
    36: {
        y: 0,
        x: 3,
    },
    37: {
        y: 0,
        x: -5,
    },
    38: {
        x: 0,
        y: 0,
    },
};

const ToothChartService = {
    getToothTexts: function(id, x, y, selected) {
        const textX = toothChartPostions[id] ? x + toothChartPostions[id].x : x;
        const textY = toothChartPostions[id] ? y + toothChartPostions[id].y : y;
        return("<tspan class=\"" + (selected ? "selected" : "") + "\" style=\"font-size: 27px; font-weight: 600; fill: " + (selected ? "#1565c0;" : "#000;") + "\" x=\"" + textX + "\" y=\"" + textY + "\">" + Helper.getToothNotation(id) + "</tspan>");
    },
};

export default ToothChartService;
